import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../../stores/authStore';
import { ROUTES } from '../../../config/routes';
import { Button } from '../../../components/ui/button';
import { api } from '../../../services/api';
import { getTrialRemainingDays } from '../../../lib/utils';

export const TrialCtaBanner: React.FC = () => {
  const { user } = useAuthStore();
  const navigate = useNavigate();

  const trialRemainingDays = user?.trial_ends_at
    ? getTrialRemainingDays(user.trial_ends_at)
    : null;

  if (trialRemainingDays === null || trialRemainingDays > 7 || trialRemainingDays === 0) return null;

  const isUrgent = trialRemainingDays <= 3;

  return (
    <div
      data-testid="trial-cta-banner"
      className={[
        'rounded-lg p-3 border',
        isUrgent
          ? 'urgent bg-red-50 border-red-300'
          : 'info bg-blue-50 border-blue-300',
      ].join(' ')}
    >
      <p className={`text-xs font-medium mb-2 ${isUrgent ? 'text-red-700' : 'text-blue-700'}`}>
        {trialRemainingDays === 1
          ? 'トライアル残り 1日。プランをアップグレードして機能を継続しましょう'
          : `トライアル残り ${trialRemainingDays}日。プランをアップグレードして機能を継続しましょう`}
      </p>
      <Button
        size="sm"
        data-testid="trial-cta-upgrade-button"
        className="w-full text-xs"
        onClick={() => {
          api.post('/subscription/conversion-event', { event_type: 'cta_click', source: 'trial_modal' }).catch(() => {});
          navigate(ROUTES.SUBSCRIPTION);
        }}
      >
        アップグレード
      </Button>
    </div>
  );
};
